module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/meal-415f029d89feb44ea3d02add8c14a4b6.webp";